export const PIXEL = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII="
export const PIXEL_TRANSPARANT = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="

export const TIMELINE_CONFIG_WARNINGS = new Map([
  ["NOT_TIMELINE", {
    warning: false,
    color: 'info'
  }],
  ["LESS_THEN_TWO_BLOCKS", {
    warning: 'Timeline screen is not properly configured. It needs two blocks.',
    color: 'danger'
  }],
  ["FIRST_BLOCK_MY_TIMELINE", {
    warning: 'First block should contain the my_timeline autofill function.',
    color: 'danger'
  }],
  ["SECOND_BLOCK_LINK", {
    warning: 'Second block should be a link block and contain at least one link item.',
    color: 'danger'
  }],
  ["TOO_MANY_BLOCKS", {
    warning: 'There are too many blocks on the screen.',
    color: 'danger'
  }],
  ["SUCCESS", {
    warning: false,
    color: 'success'
  }],
]);
